import { gql } from '@apollo/client';

export const UPDATE_USER_PROFILE = gql`
  mutation UpdateUserProfile($name: String, $phoneNumber: String, $address: String, $city: String, $postalCode: String, $about: String) {
    updateUserProfile(input: { name: $name, phoneNumber: $phoneNumber, address: $address, city: $city, postalCode: $postalCode, about: $about }) {
      user {
        id
        name
        phoneNumber
        address
        city
        postalCode
        about
      }
      errors
    }
  }
`;
